import React, { Component } from 'react'
import { Dialog } from 'material-ui'

class Modal extends Component {
  render() {
    const { header = '', show = false, children } = this.props
    const { headerStyle, containerStyle } = styles
    return (
      <Dialog
        title={header}
        actions={children}
        open={show}
        titleStyle={headerStyle}
        style={containerStyle}
      />
    )
  }
}

const styles = {
  containerStyle: {
    alignItems: 'center',
    justifyContent: 'center'
  },
  headerStyle: {
    color: '#3fa6c1',
    textAlign: 'center'
  }
}

export { Modal }



// WEBPACK FOOTER //
// ./src/components/common/Modal.js